import { Guid } from 'guid-typescript';

export class GetAllContactsBasedonType {
  static readonly type = '[REPORTSETTING] Get All Contacts Based on Type';

  constructor(public contactType: any) {}
}
export class GetAllContactsBasedonId {
  static readonly type = '[REPORTSETTING] Get All Contacts Based on Id';

  constructor(public contactId: Guid) {}
}

export class SaveCompanyContacts {
  static readonly type = '[report-setting] Save Company Contacts';

  constructor(public contactDetails: any) {}
}

export class DeleteContact {
  static readonly type = '[report-setting] Delete Contact';

  constructor(public contactId: Guid) {}
}

export class GetTrusteesDataById {
  static readonly type = '[report-setting] Get Trustees Data By Id';

  constructor(public type: any) {}
}

export class GetTrusteesDataByPeriodId {
  static readonly type = '[report-setting] Get Trustees Data By PeriodId';

  constructor(public type: any, public periodId: any) {}
}
export class SaveTrusteeDisclosures {
  static readonly type = '[report-setting] Save Trustee Disclosures';

  constructor(public reportDetails: any) {}
}
export class GetBalancesheetDataById {
  static readonly type = '[report-setting] Get Balancesheet Data By Id';

  constructor(public type: any) {}
}
export class SaveBalancesheetDisclosures {
  static readonly type = '[report-setting] Save Balance sheet Disclosures';

  constructor(public reportDetails: any) {}
}

export class GetAllIndependentExaminers {
  static readonly type = '[report-setting] Get All Independent Examiners';
}

export class GetExaminersBasedonId {
  static readonly type = '[report-setting] Get Examiners Based on Id';

  constructor(public examinerId: any) {}
}

export class SaveIndependentExaminers {
  static readonly type = '[report-setting] Save Independent Examiners';

  constructor(public examinerDetails: any) {}
}

export class DeleteExaminer {
  static readonly type = '[report-setting] Delete Examiners';

  constructor(public examinerId: any) {}
}

